import { FC } from 'react';
import { Point3D } from '../../types/sagittalTypes';
import { Line } from '@react-three/drei';

interface Line3DProps {
  start: Point3D;
  end: Point3D;
  alwaysOnTop?: boolean;
  color?: string;
}

export const Line3D: FC<Line3DProps> = ({
  start,
  end,
  alwaysOnTop = false,
  color = 'red',
}) => {
  return (
    <Line
      points={[start, end]}
      color={color}
      linewidth={2}
      depthTest={!alwaysOnTop}
      depthWrite={!alwaysOnTop}
    />
  );
};
